module.exports = __webpack_public_path__ + "img/yellow-h.38a397ad.svg";